import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
  resource,
  TemplateRef,
  viewChild,
} from '@angular/core';

import { IsDefinedNotEmptyPipe, ResolvableModal } from '@softline/ui-core';
import { ArtikelMenge, EinheitAuswahlItem } from '@softapps/lager/core';
import { KommissionierungService } from '../../services/kommissionierung.service';
import { ResourceContainerComponent } from '@softapps/core';
import { MengenEingabeComponent } from '@softline/application';
import { isDefinedNotEmpty } from '@softline/core';

@Component({
  selector: 'soft-additional-item-quantity-modal',
  imports: [ResourceContainerComponent, MengenEingabeComponent, IsDefinedNotEmptyPipe],
  templateUrl: './additional-item-quantity-modal.component.html',
  styleUrl: './additional-item-quantity-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdditionalItemQuantityModalComponent extends ResolvableModal<ArtikelMenge> {
  readonly id = input<number>();
  readonly quantity = model<number>(1);

  override readonly bottomTemplate = viewChild('bottomTemplate', {
    read: TemplateRef,
  });

  readonly service = inject(KommissionierungService);

  readonly resource = resource({
    params: () => this.id(),
    loader: async ({ params: id }) => {
      return this.service.loadArtikelMenge(id);
    },
  });

  protected readonly isDefinedNotEmpty = isDefinedNotEmpty;

  closeModal(): void {
    const value = this.resource.value();

    if (isDefinedNotEmpty(value)) {
      this.resolve({
        ...value,
        menge: this.quantity(),
        menge_lg: this.quantity(),
        einheitenAuswahl: value.einheitenAuswahl?.filter((o) => o.menge !== null),
      });
    }
  }

  updateEinheitAuswahlQuantity(quantity: number, ehAuswahl: EinheitAuswahlItem): void {
    const value = this.resource.value();
    if (!value) return;

    const entries = value.einheitenAuswahl ?? [];
    const entryIndex = entries.findIndex((o) => o.einheit.id === ehAuswahl.einheit.id);

    entries[entryIndex] = {
      ...entries[entryIndex],
      menge: quantity ?? 0,
    };

    this.resource.value.set({ ...value, einheitenAuswahl: entries });
  }
}
